export default import.meta.ROLLDOWN_FILE_URL_yPIIdXU6y9Ly12lnB3YDIw